import { ListItem, ListItemIcon, ListItemText, Skeleton } from '@mui/material';
import { MathSymbolIcon, MathSymbolType } from '../../icons/MathSymbols';
import { ReactNode } from 'react';

export type BreakdownListItemVariant = 'form' | 'confirm';

export type BreakdownListItemProps = {
  icon: MathSymbolType;
  variant: BreakdownListItemVariant;
} & ({ title: ReactNode; value: ReactNode; loading: false } | { loading: true });

export function BreakdownListItem(props: BreakdownListItemProps) {
  const label = props.loading ? <Skeleton width={128} /> : props.title;
  const value = props.loading ? <Skeleton width={48} /> : props.value;

  return (
    <ListItem secondaryAction={props.variant === 'confirm' ? value : label}>
      <ListItemIcon>
        <MathSymbolIcon type={props.icon} />
      </ListItemIcon>
      <ListItemText primary={props.variant === 'confirm' ? label : value} />
    </ListItem>
  );
}
